import { createSelector } from 'reselect'

import { sessionSelector } from 'root-api'

export const currentUserSelector = createSelector(
  (state) => state.current_user,
  (currentUser) => (currentUser?.email ? currentUser : null)
)

export const currentUserEmailSelector = createSelector(
  currentUserSelector,
  (currentUser) => {
    if (!currentUser) return null
    return currentUser.email
  }
)

export const currentUserLocaleSelector = createSelector(
  currentUserSelector,
  (currentUser) => {
    if (!currentUser) return null
    return currentUser.locale
  }
)

export const recentUserSelector = createSelector(
  sessionSelector,
  (state) => state.recent
)

export const calAnonymousIdSelector = createSelector(
  (state) => state.current_user,
  (currentUser) => currentUser?.cal_anonymous_id
)
